<template lang="pug">
  nav.sharer
    a(href="#" @click.prevent="fbShare")
      font-awesome-icon(:icon="['fab', 'facebook-f']")
    a(href="#" @click.prevent="twShare")
      font-awesome-icon(:icon="['fab', 'twitter']")
    a.mobileonly(:href="wsShare" target="_blank")
      font-awesome-icon(:icon="['fab', 'whatsapp']")
</template>
<script>
export default {
  props: {
    baseurl: String,
    slug: String,
    title: String,
    description: String,
    img: String,
    hashtag: String,
    brandtitle: String,
    reporttitle: String
  },
  computed: {
    wsShare(){
      this.getUpdatedContent()
      const textlink = encodeURIComponent(this.title + ' - ' + this.description + ' - ' + this.reporttitle + ' - ' + this.brandtitle + ' - ' + this.url)
      const sharelink = ` https://wa.me/?text=${textlink}`
      return sharelink
    }
  },
  methods: {
    getUpdatedContent(){
      this.fbtitle = this.title + ' - ' + this.reporttitle + ' - ' + this.brandtitle
      this.fbdescription = this.description
      this.fbimg = this.baseurl + this.img
      this.twtext = this.title + ' - ' + this.description + ' - ' + this.reporttitle + ' - ' + this.brandtitle
      this.twhashtag = this.hashtag
      this.twimg = this.baseurl + this.img
      this.url = this.baseurl + this.slug
    },
    twShare() {
      this.getUpdatedContent()
      const textlink = encodeURIComponent(this.twtext)
      const sharelink = `https://twitter.com/share?url=${this.url}&text=${textlink}&hashtag=${this.twhashtag}`
      const w = 500
      const h = 300
      const left = (screen.width/2)-(w/2)
      const top = (screen.height/4)-(h/2)
      window.open(sharelink, 'Compartir en Twitter', 'top=' + top + ', left=' + left + ', width=' + w + ', height=' + h)
    },
    fbShare() {
      this.getUpdatedContent()
      console.log(this.fbimg)
      this.$FB.ui({
        method: 'share_open_graph',
        action_type: 'og.shares',
        action_properties: JSON.stringify({
          object: {
            'og:url': this.url,
            'og:title': this.fbtitle,
            'og:description': this.fbdescription,
            'og:image': this.fbimg
          }
        })
      })
    },
  }
}
</script>
<style lang="scss" scoped>
  .sharer {
    display: flex;
    align-items: center;
    justify-content: center;
    p{
      margin: 0;
      padding-right: 1rem;
      @media all and (max-width: 600px){
        display: none;
      }
    }
    @media all and (max-width: 600px){
      margin-top: .4rem;
    }
    a{
      color: black;
      border: 2px solid black;
      width: 4rem;
      height: 4rem;
      display: flex;
      align-items: center;
      justify-content: center;
      border-radius: 4rem;
      margin-right: .5rem;
      transition: all .3s;
      @media all and (max-width: 600px){
        width: 2rem;
        height: 2rem;
      }
      &:hover,
      &:focus,
      &:active{
        color: white;
        background-color: black;
      }
    }
  }
</style>


